import React, {useContext} from "react";
import {Blog} from "interfaces";
import { Col, Divider, Row, Skeleton, Space, Card} from "antd";
import {CalendarOutlined, UserOutlined} from "@ant-design/icons";
import {Link} from "react-router-dom";
import {BlogContext} from "contexts/blog";

const Cards : React.FC = () => {

    const [isLoading, datasource] = useContext(BlogContext);

    return (
        <Row gutter={[20, 20]}>
            {
                (isLoading ? new Array(13).fill({}, 0, 13) : datasource)
                    .map((item : Blog, x) => {
                            return item.key ? (
                                <Col key={x} lg={12} md={12} sm={24} xs={24}>
                                    <div className={"card-list"}>
                                        <Link to={`/blog/${item.key}/${item?.title?.replace(/ /g, "-")}`}>
                                            <Card
                                                cover={isLoading ? (<Skeleton.Avatar size={500} shape={"square"} active={true} />)
                                                    : (
                                                        <>
                                                            <img alt="example" src={item?.image?.url}/>
                                                        </>
                                                    )}
                                            >
                                                <div className={"card-list-body"}>
                                                    {
                                                        isLoading
                                                            ? <Skeleton active={true} paragraph={{rows : 2}} />
                                                            : <>
                                                                <div className={"title"}>
                                                                    <h4>{item.title}</h4>
                                                                </div>
                                                                <div className={"description"}>
                                                                    <p>{item.content.length > 100 ? item.content.slice(0, 100) + "....." : item.content}</p>
                                                                </div>
                                                            </>
                                                    }
                                                </div>
                                                <Divider style={{margin: "10px 0"}}/>
                                                <div className={"card-list-footer"}>
                                                    <Space>
                                                        <div>
                                                            {
                                                                isLoading
                                                                    ? ""
                                                                    : <p><UserOutlined/> WASD Labs</p>
                                                            }
                                                        </div>
                                                        <div>
                                                            {
                                                                isLoading
                                                                    ? ""
                                                                    : <p><CalendarOutlined/> {item.timestamp}</p>
                                                            }
                                                        </div>
                                                    </Space>
                                                </div>
                                            </Card>
                                        </Link>
                                    </div>
                                </Col>
                            ) : null
                        }
                    )
            }
        </Row>
    )
}

export default React.memo(Cards)